import router, { resetRouter } from './router'
import store from './store'
import storage from 'store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import notification from 'ant-design-vue/es/notification'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { i18nRender } from '@/locales'
import { authoriedPlatformCode, allCodes } from './config/contanst'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const allowList = ['login', 'register', 'registerResult', 'findPassword'] // no redirect allowList  ,'smartTools','createLive'
const loginRoutePath = '/user/login'
const defaultRoutePath = '/user/login' //'/smartTools/SmartTools'//默认页
const codeToPlatform = {}
for (const [platform, code] of Object.entries(authoriedPlatformCode)) {
  if (!codeToPlatform[code]) {
    codeToPlatform[code] = []
  }
  codeToPlatform[code].push(platform)
}
function getStateParams(url) {
  if (!url) return
  const params = {}
  console.log('url>>>>', url)
  const queryString = url.split('?')[1]
  if (queryString) {
    const pairs = queryString.split('&')
    for (let i = 0; i < pairs.length; i++) {
      const [key, value] = pairs[i].split('=')
      if (!params[key]) {
        params[key] = value
      } else if (Array.isArray(params[key])) {
        params[key].push(value)
      } else {
        params[key] = [params[key], value]
      }
    }
  }
  return params
}
router.beforeEach((to, from, next) => {
  let matchedCode = null
  let platform = null
  let otherParams = { ...to.query }
  const keys = Object.keys(otherParams)
  let formattedRedirectParams
  let redirectKeys
  if (otherParams.redirect) {
    formattedRedirectParams = getStateParams(otherParams.redirect)
    redirectKeys = Object.keys(formattedRedirectParams)
  }

  if (
    keys.includes('code') &&
    keys.includes('state') &&
    !Array.isArray(otherParams.state) &&
    !keys.includes('businessId')
  ) {
    platform = '京东'
    matchedCode = otherParams.code
    otherParams.state = otherParams.state
  } else if (Array.isArray(otherParams.state) && keys.includes('code')) {
    platform = '淘宝/天猫'
    matchedCode = otherParams.code
    otherParams.state = otherParams.state
    // console.log('formattedRedirectParams', otherParams)
  } else if (keys.includes('businessId')) {
    platform = '美团'
  } else if (keys.includes('wphcode') && !keys.includes('state')) {
    platform = '唯品会'
    matchedCode = otherParams.wphcode
  } else if (keys.includes('code') && !keys.includes('state')) {
    platform = '微博'
    matchedCode = otherParams.code
  }
  // matchedCode = otherParams.redirect.split('=')[1]

  // delete otherParams.redirect
  for (const [paramName, paramValue] of Object.entries(to.query)) {
    if (allCodes.includes(paramName)) {
      matchedCode = paramValue
      // 移除匹配到的参数，避免重复传递
      // delete otherParams[paramName]
      break
    }
    if (matchedCode) {
      break
    }
  }
  // if (platform) {
  //   if (otherParams.businessId && otherParams.businessId === '50') {
  //     platform = '美团'
  //   } else if (platform.includes('唯品会')) {
  //     platform = '唯品会'
  //   }
  // }
  const firstLoagin = storage.get('firstLogin')
  NProgress.start()
  to.meta && typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`)
  //1. 是否是login
  const token = storage.get(ACCESS_TOKEN)
  if (to.path !== loginRoutePath) {
    if (token) {
      if (to.path === loginRoutePath) {
        // this.$store.commit('SET_TOKEN', '')
        // this.$store.commit('SET_ROLES', [])
        // storage.remove(ACCESS_TOKEN)
        // resetRouter()
        next({ path: defaultRoutePath })
        NProgress.done()
      } else {
        store.dispatch('GetPlatformList')
        if (store.getters.addRouters.length === 0) {
          // store
          //   .dispatch('GetInfo')
          //   .then(res => {//undefined
          //     console.log(res,'用户信息')
          // 根据用户权限信息生成可访问的路由表
          store.dispatch('GenerateRoutes').then(() => {
            // 动态添加可访问路由表
            // VueRouter@3.5.0+ New API
            resetRouter()
            // // 重置路由 防止退出重新登录或者 token 过期后页面未刷新，导致的路由重复添加
            store.getters.addRouters.forEach((r) => {
              router.addRoute(r)
            })

            //判断路由表中是否有创建品牌页面，如果有就跳转创建品牌页，没有就跳转首页
            const routerItem = store.getters.addRouters?.[0]?.children
            // const hasCreateBrandPage = routerItem.some((item) => item.name === 'CreateBrand')
            // console.log('hasCreateBrandPage', hasCreateBrandPage)
            if (from.path === loginRoutePath && firstLoagin === 0) {
              next({
                path: '/personalCenterIndex',
                query: {
                  flag: 'first',
                },
              })
              return
            }

            // 请求带有 redirect 重定向时，登录自动重定向到该地址
            const redirect = decodeURIComponent(from.query.redirect || to.path)
            // console.log('redirect', to.path === redirect)
            if (to.path === redirect) {
              // set the replace: true so the navigation will not leave a history record
              next({ ...to, replace: true })
            } else if (to.query.code) {
              next({ path: '/personalCenterIndex?&code=' + to.query.code })
            } else {
              //登陆页来的要调查询订阅的接口，在websocket onopen中调用的
              if (from.name === 'login') {
                next({
                  path: redirect,
                  query: {
                    from: 'login',
                  },
                })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            }
          })
          // })
          // .catch((err) => {
          //   console.log(err)
          //   notification.error({
          //     message: '错误',
          //     description: '请求用户信息失败，请重试'
          //   })
          // 失败时，获取用户信息失败时，调用登出，来清空历史保留信息
          // store.dispatch('Logout').then(() => {
          //   next({ path: loginRoutePath, query: { redirect: to.fullPath } })
          // })//hxn
          // })//hxn
          // next();

          // })//hxn
        } else {
          if (platform && to.path !== '/personalCenterIndex') {
            next({
              path: 'personalCenterIndex',
              query: {
                ...otherParams,
                code: matchedCode,
                platform: platform,
              },
            })
          } else {
            next()
          }
        }
      }
    } else {
      if (allowList.includes(to.name)) {
        // 在免登录名单，直接进入
        next()
      } else {
        console.log('不是白名单内进入loginRoutePath》》', loginRoutePath, to.fullPath)
        next({ path: loginRoutePath })
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    }
  } else {
    if (token && platform) {
      next({
        path: 'personalCenterIndex',
        query: {
          ...otherParams,
          code: matchedCode,
          platform: platform,
        },
      })
    } else {
      next()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
